/**
 * The live scorebook is the one screen where a floating control would sit on
 * the 64px targets and the sync indicator (issue #175). Setup and the box
 * score are not that screen.
 */
export function isLiveScorebookPath(pathname: string): boolean {
  return /^\/scorebook\/[^/]+$/i.test(pathname.replace(/\/+$/, ''));
}
